import React from 'react';
import {
  Button,
  Typography,
  Card,
  CardActions,
  CardBody,
  CardMedia,
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import data from './data';

const TRACKING_PARAM = '?emt_lcp25';

export const Capabilities = ({ city, state }) => {
  return (
    <div className="sui-flex sui-flex-col sui-w-full" data-component="Capabilities">
      <div className="sui-mb-3">
        <Typography variant="h2" weight="display" height="snug" color="primary">
          Find What You Need Online or at Home Depot Stores Near {city}, {state}
        </Typography>
      </div>

      <div className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-2 md:sui-grid-cols-3 lg:sui-grid-cols-4 sui-gap-4">
        {data.map(({ title, description, imageUrl, ctaUrl }, index) => (
          <Card key={`${title}-${index}`} CardContentProps={{ grow: true }}>
            <CardMedia src={imageUrl} alt={title} aspect="wide" loading="lazy" />
            <Typography variant="h4" weight="display">{title}</Typography>
            <CardBody>
              <Typography>{description}</Typography>
            </CardBody>
            <CardActions>
              <Button
                href={`${ctaUrl}${TRACKING_PARAM}`}
                variant="secondary"
              >
                Learn More
              </Button>
            </CardActions>
          </Card>
        ))}
      </div>
    </div>
  );
};

Capabilities.displayName = 'Capabilities';
Capabilities.propTypes = {
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
};

export default Capabilities;
